// extracted by mini-css-extract-plugin
module.exports = {"bodyTitle__wrapper":"bodyTitle__wrapper","bodyTitle__nearArea":"bodyTitle__nearArea","bodyTitle__link":"bodyTitle__link"};